<script>
  import { FileText } from 'lucide-svelte';

  export let iconClass = '';
</script>

<FileText class={iconClass} />
